import { render, staticRenderFns } from "./TimeBenefitsDetail.vue?vue&type=template&id=1f208237&scoped=true"
import script from "./TimeBenefitsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeBenefitsDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TimeBenefitsDetail.vue?vue&type=style&index=0&id=1f208237&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f208237",
  null
  
)

export default component.exports